import React from "react";

import { TabsComponent, Tab } from "../TabsComponent/TabsComponent";

interface ParentComponentProps {
    tabs: Tab[];
}

export function ParentComponent({ tabs }: ParentComponentProps) {
    return <TabsComponent tabs={tabs} defaultTab={tabs[0]?.value} />;
}
